<script>
	import "./InfoCard.scss";

	import Card, {Content, PrimaryAction, Media, MediaContent, Actions, ActionButtons, ActionIcons} from '@smui/card';
	import Button, {Label} from '@smui/button';

	import { onMount, afterUpdate, tick } from 'svelte';
	import { get, writable } from 'svelte/store';
	import VesselGraph from '../../Models/VesselGraph.svelte';
	import VesselProperty from '../../Models/Enums/VesselProperty';
	import VesselIDType from '../../Models/Enums/VesselIDType';

	import User from '../../Branding/User';
	import Feature from '../../Branding/Feature';

	import VesselComments from '../VesselComments/View.svelte';

	import Router from '../../Router';
	import InfoCardStore from '../InfoCard/Store';
	
	import VesselCommentsStore from "../VesselComments/Store";

	import InfoCardGeneralPanel from "./InfoCardGeneralPanel.svelte";
	import InfoCardEnhancedVesselData from "./InfoCardEnhancedVesselData.svelte";
import ModelType from "../../Models/ModelType";

	let containerElement = InfoCardStore.element;
	let model = InfoCardStore.model;
	let modelType = InfoCardStore.modelType;
	let visible = InfoCardStore.visible;
	let lastUpdated = InfoCardStore.meta.lastUpdated;

	let curV = $model;
	model.subscribe((v) => {
		if (v && v !== curV) {
			$tab = "general";
			curV = v;
		}
	});

	let snapshot;

	let tab = writable("general");
	
	let generalPanel = null;
	let moreInfoPanel = null;
	let generalTabElement = null;
	let graphingTabElement = null;
	let notesTabElement = null;
	let moreInfoTabElement = null;
	let panelMinHeight = 290;

	let tabsub = tab.subscribe((t) => {
		if (generalTabElement !== null && moreInfoTabElement !== null) {
			if ($tab === "general") {
				if (generalTabElement)	generalTabElement.classList.add("active");
				if (moreInfoTabElement) moreInfoTabElement.classList.remove("active");
				if (notesTabElement) 	notesTabElement.classList.remove("active");
				if (graphingTabElement) graphingTabElement.classList.remove("active");
			}
			else if ($tab === "graphs") {
				if (generalTabElement) 	generalTabElement.classList.remove("active");
				if (moreInfoTabElement) moreInfoTabElement.classList.remove("active");
				if (notesTabElement) 	notesTabElement.classList.remove("active");
				if (graphingTabElement) graphingTabElement.classList.add("active");
			}
			else if ($tab === "discussion") {
				if (generalTabElement) 	generalTabElement.classList.remove("active");
				if (moreInfoTabElement) moreInfoTabElement.classList.remove("active");
				if (graphingTabElement) graphingTabElement.classList.remove("active");
				if (notesTabElement) 	notesTabElement.classList.add("active");

			}
			else if ($tab === "extra") {
				if (generalTabElement)	generalTabElement.classList.remove("active");
				if (moreInfoTabElement) moreInfoTabElement.classList.add("active");
				if (graphingTabElement) graphingTabElement.classList.remove("active");
				if (notesTabElement) 	notesTabElement.classList.remove("active");				
			}
		}
	});

	let timeSliderValue = writable(0);
	let timeSliderValueMax = writable(0);

	onMount(()=>{
		// updateChart();

		return () => {
			tabsub();
		}
	});
	$: {
		$timeSliderValue;
		$timeSliderValueMax;
		$modelType;
		if ($model) {
			timeSliderValue = $model.group.timeSliderData.value;
			timeSliderValueMax = $model.group.timeSliderData.max;
			snapshot = $model.hasActiveSnapshot();
		}
	}

	$: {
		if (!$visible) {
			$tab = "general";
		}
	}


	let canGotoVesselHistory = () => {
		if (!User.hasFeature(Feature.VESSEL_HISTORY.RESTRICTED_INPUTS)) {
			return true;
		}
		let limitedImos = User.vhRestrictedInputs(VesselIDType.IMO);
		let limitedMmsis = User.vhRestrictedInputs(VesselIDType.MMSI);
		if (limitedImos.indexOf(""+$model.imo) >= 0
			// || limitedMmsis.indexOf(""+mmsi) >= 0
			) {
			return true;
		}
		return false;
	};
	let canGotoVesselHistoryResult = writable(false);
	$: {
		$visible;
		$lastUpdated;
		$canGotoVesselHistoryResult = canGotoVesselHistory();
	}	

</script>

<div bind:this={$containerElement} class:hidden={!$visible}>
	<Card id="info-card" class="card">
		<Content>
			{#if $model}
				<div class='title'>
					<h3>
						<span>{$model.name}</span>
						{#if snapshot}
							<span>(Historic)</span>
						{/if}
					</h3>
				</div>
				<button bind:this={generalTabElement} class='tab-btn active' on:click={()=>{ $tab = "general"; }}>General</button>

				{#if $modelType === ModelType.VESSEL}
					{#if User.hasFeature(Feature.MARITIME.ENHANCED_VESSEL_DATA.VIEW)}
						<button bind:this={moreInfoTabElement}  class='tab-btn' on:click={(e)=>{ $tab = "extra"; }}>More Information</button>
					{/if}

					{#if User.hasFeature(Feature.GRAPHS.VIEW) &&
						$model && $model.historicPath && $model.historicPath.stops.length > 1}
						<button bind:this={ graphingTabElement }  class='tab-btn' on:click={(e)=>{ $tab = "graphs"; }}>Graphs</button>
					{/if}
					
					{#if User.hasFeature(Feature.MARITIME.VESSEL_COMMENTS.VIEW)}
						<button bind:this={ notesTabElement }  class='tab-btn' on:click={(e)=>{ $tab = "discussion"; }}>Discuss</button>
					{/if}
				{/if}

				{#if $tab === "general"}
					<div bind:this={generalPanel} id='info-card-general' style={"min-height: " + panelMinHeight + "px;"}>
						<InfoCardGeneralPanel vessel={model}/>
					</div>
				{:else if $tab === "extra"}
					<div bind:this={moreInfoPanel} id='info-card-moreinfo' style={"min-height: " + panelMinHeight + "px; height: " + panelMinHeight + "px; overflow-y: scroll;"}>
						<InfoCardEnhancedVesselData vessel={model}/>
					</div>
				{:else if $tab === "graphs"}
					<div>
						<VesselGraph vessel={ model } property={ VesselProperty.SPEED } propertyOptions={[VesselProperty.SPEED, [VesselProperty.COURSE, VesselProperty.HEADING]]} height={panelMinHeight}/>
					</div>
					<!-- <div>
						<VesselGraph vessel={ vessel } property={ VesselProperty.COURSE } height={panelMinHeight/2}/>
					</div> -->
				{:else if $tab === "discussion"}
					<VesselComments vessel={ model } confirmDialog={VesselCommentsStore.confirmDialog} />
				{/if}
			{/if}
		</Content>
		<Actions>
			{#if $modelType === ModelType.AIRCRAFT}
				{#if User.hasFeature(Feature.AVIATION.AIRCRAFT_HISTORY.VIEW)}
					<Button on:click={()=>{ Router.actions.gotoAircraftHistory($model); }}><Label>Aircraft History</Label></Button>
				{/if}
				<!-- {#if User.hasFeature(Feature.MEASURE.VIEW)}
					<Button on:click={()=>{ Router.actions.gotoMeasure($model); }}><Label>Measure</Label></Button>
				{/if} -->
				{#if User.hasFeature(Feature.ENVIRONMENT.VIEW)}
					<Button on:click={()=>{ Router.actions.gotoEnvironment($model); }}><Label>Weather</Label></Button>
				{/if}
			{:else if $modelType === ModelType.VESSEL}
				{#if User.hasFeature(Feature.VESSEL_HISTORY.VIEW) ||
					User.hasFeature(Feature.MEASURE.VIEW) ||
					User.hasFeature(Feature.VESSELS_NEARBY.VIEW)}
					{#if User.hasFeature(Feature.VESSEL_HISTORY.VIEW) && $canGotoVesselHistoryResult}
						<Button on:click={()=>{ Router.actions.gotoVesselHistory($model); }}><Label>Vessel History</Label></Button>
					{/if}
					{#if User.hasFeature(Feature.VESSELS_NEARBY.VIEW)}
						<Button on:click={()=>{ Router.actions.gotoVesselsNearby($model); }}><Label>Vessels Nearby</Label></Button>
					{/if}
					{#if User.hasFeature(Feature.MEASURE.VIEW)}
						<Button on:click={()=>{ Router.actions.gotoMeasure($model); }}><Label>Measure</Label></Button>
					{/if}
					{#if User.hasFeature(Feature.ENVIRONMENT.VIEW)}
						<Button on:click={()=>{ Router.actions.gotoEnvironment($model); }}><Label>Weather</Label></Button>
					{/if}
				{/if}
			{/if}
			<Button on:click={()=>{ InfoCardStore.actions.close(); }}><Label>Close</Label></Button>
		</Actions>
	</Card>
</div>
